module.exports = __webpack_public_path__ + "img/bg4.5d9ff015.png";